"use client";

import { c as _c } from "react/compiler-runtime";
import { ConfluentReferralSteps } from "@/configuration/groups/confluent-all-star/components/referral-steps";
import { ReferralWorkflowLayout } from "@/configuration/groups/confluent-all-star/components/referral-timeline";
import PatientCard from "@/src/components/cards/patient-card/patient-card";
import ReferralCard from "@/src/components/cards/referral-card/referral-card";
import type { Referral } from "@/src/models/documents/referral";
import type { Task } from "@/src/models/task";
import type { TaskApproval } from "@/src/models/task-approval";
import type { TaskStep } from "@/src/models/task-step";
export function ConfluentReferralInstructions(t0) {
  const $ = _c(12);
  const {
    view,
    referral,
    task,
    taskSteps,
    pendingApproval
  } = t0;
  if (view === "steps") {
    let t1;
    if ($[0] !== pendingApproval || $[1] !== task || $[2] !== taskSteps) {
      t1 = <ReferralWorkflowLayout><ConfluentReferralSteps task={task} taskSteps={taskSteps} pendingApproval={pendingApproval} /></ReferralWorkflowLayout>;
      $[0] = pendingApproval;
      $[1] = task;
      $[2] = taskSteps;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="text-sm text-muted-foreground">These are the patient and referral details recorded in Valerie. Review the Steps tab and verify the results in Clinicient before completing this task.</p>;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== referral.patient) {
    t2 = <PatientCard patient={referral.patient} />;
    $[5] = referral.patient;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== referral) {
    t3 = <ReferralCard referral={referral} isEditable={true} />;
    $[7] = referral;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <ReferralWorkflowLayout>{t1}{t2}{t3}</ReferralWorkflowLayout>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}